import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "delete-quote-modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "delete-quote-modal=label"
}, " Are you sure? ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner-border me-2 spinner-border-sm"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Delete ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(false, null))),
            "aria-label": "Close"
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", null, "Delete quote " + _toDisplayString(_ctx.quote ? _ctx.quote.title : "") + " ?", 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal(false, null)))
          }, " Close "),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args))),
            disabled: _ctx.loading,
            type: "button",
            class: "btn btn-danger"
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : _createCommentVNode("", true),
            _hoisted_12
          ], 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}